/**
 * Find Sections 请求参数
 */
export interface FindSectionsRequest {
    /**
     * 任务 ID
     */
    task_id: string;
}

/**
 * 章节文档项
 */
export interface SectionDoc {
    /**
     * 章节 ID
     */
    'tc@section_id': string;
}

/**
 * 查找结果数据
 */
export interface FindResultData {
    /**
     * 文档列表
     */
    docs: SectionDoc[];
    /**
     * 相关性评分列表
     */
    scores: number[];
}

/**
 * 元数据信息
 */
export interface FindMetadata {
    /**
     * 是否启用向量搜索
     */
    vector_enabled: boolean;
    /**
     * 是否启用 BM25 搜索
     */
    bm25_enabled: boolean;
    /**
     * 是否启用分类
     */
    category_enabled: boolean;
    /**
     * RRF K 参数
     */
    rrf_k: number;
    /**
     * RRF Top K 参数
     */
    rrf_top_k: number;
    /**
     * 分类插入位置
     */
    category_insert_position: number;
    /**
     * 总结果数
     */
    total_results: number;
    /**
     * 向量搜索结果数
     */
    vector_results: number;
    /**
     * BM25 搜索结果数
     */
    bm25_results: number;
    /**
     * 分类结果数
     */
    category_results: number;
}

/**
 * 查找结果
 */
export interface FindResult {
    /**
     * 进程 ID
     */
    pid: string;
    /**
     * 状态
     */
    status: string;
    /**
     * 数据
     */
    data: FindResultData;
    /**
     * 元数据
     */
    metadata: FindMetadata;
    /**
     * TS 编号
     */
    ts_code: string;
}

/**
 * 章节项
 */
export interface SectionItem {
    /**
     * 标准 ID
     */
    std_id: string;
    /**
     * TS 编号
     */
    ts_number: string;
    /**
     * TS 版本
     */
    ts_version: string;
    /**
     * 查找结果
     */
    result: FindResult;
    /**
     * 是否成功
     */
    success: boolean;
}

/**
 * Find Sections 响应
 */
export interface FindSectionsResponse {
    /**
     * 请求状态
     */
    status: boolean;
    /**
     * 错误代码
     */
    error_code: number;
    /**
     * 错误消息
     */
    error_msg?: string;
    /**
     * 响应数据
     */
    data?: {
        /**
         * 章节列表
         */
        sections: SectionItem[];
    };
}

export const FindSectionsApi = Symbol('FindSectionsApi');

/**
 * Find Sections API
 */
export interface FindSectionsApi {
    /**
     * 查找相关章节
     */
    findSections(request: FindSectionsRequest): Promise<FindSectionsResponse>;
}
